module.exports = __webpack_public_path__ + "img/046.72a2a8f1.png";